module.exports = __webpack_public_path__ + "30db29f718d335326412369c5da1edec.svg";